export type BoschUiBackgroundType =
  | 'primary'
  | 'secondary'
  | 'contrast'
  | 'floating'
  | 'floating-shadow-s'
  | 'floating-shadow-m'
  | 'dimmed';
